import { useMemo, useEffect } from 'react';
export const useMutationObserver = ({ elements, callback, options, shouldObserve = true, }) => {
    const observer = useMemo(() => new MutationObserver(callback), [callback]);
    useEffect(() => {
        if (shouldObserve) {
            elements
                .filter((element) => !!element)
                .forEach(element => {
                observer.observe(element, options);
            });
        }
        return () => observer.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldObserve, observer, options, ...elements]);
};
//# sourceMappingURL=useMutationObserver.js.map